import { API_URL } from "../config/config";
import { APIResponse } from "../types/api.types";
import { parseErrorCode } from "../utils/errorParser";

const UNKNOWN_ERROR_CODE = "0.9.999"; // ERROR CODE TO CORRECT

export let lastExecutionData: APIResponse;

let baseDeviceUUID = "";
let baseToken = "";
let baseAssociationId = "";

export const setBaseAPIDeviceUUID = (uuid: string) => {
    baseDeviceUUID = uuid;
};

export const setBaseAPIToken = (token: string) => {
    baseToken = token;
};

export const setBaseAPIAssociationId = (associationId: string) => {
    baseAssociationId = associationId;
};

export const APIQuery = async (
    path: string,
    method: 'POST' | 'GET' | 'PUT' | 'DELETE',
    headers_values: { name: string, value: string }[],
    postData?: unknown,
    tokenOverride?: string
): Promise<APIResponse> => {
    try {
        const customHeaders = headers_values.reduce((acc, { name, value }) => {
            acc[name] = value;
            return acc;
        }, {} as Record<string, string>);

        const normalizedHeaderNames = new Set(Object.keys(customHeaders).map((headerName) => headerName.toLowerCase()));
        const hasAssociationHeader = normalizedHeaderNames.has("x-association-id");
        if (baseAssociationId && !hasAssociationHeader) {
            customHeaders["x-association-id"] = baseAssociationId;
        }

        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            ...customHeaders
        };

        const resolvedToken = tokenOverride || baseToken;
        if (resolvedToken) {
            headers.Authorization = `Bearer ${resolvedToken}`;
        }

        if (baseDeviceUUID) {
            headers["X-SPORTIFY-UUID"] = baseDeviceUUID;
        }

        const response = await fetch(`${API_URL}${path}`, {
            method: method,
            headers,
            body: method === "GET" || postData === undefined ? undefined : JSON.stringify(postData)
        });

        const contentType = response.headers.get("content-type") || "";
        const data = contentType.includes("application/json") ? await response.json() : { data: await response.text() };
        const normalizedData = {
            request_id: data?.request_id ?? "",
            error_code: data?.error_code ?? `${response.status}.9.999`, // ERROR CODE TO CORRECT
            speed: data?.speed ?? "0",
            data: data?.data ?? data,
            parsed_error: parseErrorCode(data?.error_code ?? `${response.status}.9.999`) // ERROR CODE TO CORRECT
        };

        lastExecutionData = normalizedData;

        if (normalizedData.error_code === "00.01.113") // ERROR CODE TO CORRECT
            if (!window.location.pathname.includes("/auth")) {
                window.location.href = "/auth";
            }

        return normalizedData;
    } catch (err) {
        const errorResponse = { error_code: UNKNOWN_ERROR_CODE, request_id: "", speed: "0", data: err, parsed_error: parseErrorCode(UNKNOWN_ERROR_CODE) };
        lastExecutionData = errorResponse;
        return errorResponse;
    }
};
